<!-- 
    COMPONENT MINITELCONTACT
-->


<!---------- SCRIPT ---------->

<script lang="ts">

</script>
  
  
<!---------- STYLE ---------->
  
<style lang="scss">

    .minitelcontact {
        margin: 130px 0 0 0;
    }

    .text {
        font-size: 0.4em;
        animation: defilement 10s infinite linear;
        transform: rotate(8deg);
        color: $color_white;
    }

    .imgmini {
        position: relative;
        top: -130px;
        left: 20px;
    }

    .imgmini img {
        width: 100%;
    }

    @include large {
    }

    @keyframes defilement {
        0% { margin-left: 55%; }
        50% { margin-left: 30%; }
        100% { margin-left: 55%; }
    }
</style>
  
  
<!---------- TEMPLATE ---------->
<div class="minitelcontact">
    <div class="text">contact@kortefa.net</div>
    <div class="imgmini"><img src="../images/minitel_primary.png" alt="minitel"></div>
</div>